
import * as types from "../config/types";

const initialState = {
  loading: false,
  overviews: [],
  error: null
};

export default function overviewManage (state = initialState, action)  {
  switch (action.type) {
    case types.GET_OVERVIEW_LIST_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case types.GET_OVERVIEW_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        overviews: action.payload.overviews.data
      };
    }
    case types.GET_OVERVIEW_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        error: "FAILED",    
      };
    }
    default:
      return state;
  }
};

